import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { Basket } from 'src/store/slices/basket-slice';
import { createBasket } from 'src/api/basketService';

export const useCreateBasket = () =>
    useMutation<Basket, AxiosError, Basket>({
        mutationKey: ['createBasket'],
        mutationFn: (basketData) => createBasket(basketData),
    });
